// Adept Client Services - Service
// Can't start with "Adept" because it is less than "app".
(function () {
    'use strict';

    angular
        .module('app')
        .factory('zcs', zcs);

    zcs.$inject = ['$http', '$q', 'clientService', 'SchemaService'];

    function zcs($http, $q, clientService, SchemaService) {

        var service = {
            Ping: Ping,
            //unused-BrowseForFolder: BrowseForFolder,
            //unused-BrowseForFolderCheck: BrowseForFolderCheck,
            ProcessFileOperationPacket: ProcessFileOperationPacket,
            GetFileInfos: GetFileInfos,
            WindowsExplorer: WindowsExplorer,
            GetLocalVirtualLibraryPath: GetLocalVirtualLibraryPath,
            SetLocalVirtualLibraryPath: SetLocalVirtualLibraryPath,
            GetUNC: GetUNC,
            GetLocalPath: GetLocalPath,
            GetMyDocsFolder: GetMyDocsFolder,
            CreateDirectory: CreateDirectory,
            isFile: isFile,
            isDirectory: isDirectory,
            TestAccess: TestAccess,
            TestAccessList: TestAccessList,
            ExtractFile: ExtractFile,
            GetMappedFields: GetMappedFields,
            UpdateDocumentChildrenNeeded: UpdateDocumentChildrenNeeded,
            UpdateDocument: UpdateDocument,
            bAcsInitPlugInsDone: false,
            AcsInitPlugIns: AcsInitPlugIns,
            OpenFile: OpenFile,
            ValidateWorkAreas: ValidateWorkAreas,
            CopyFiles: CopyFiles
        };
        return service;

        function Ping(suppressError) {
            return clientService.put('ping', null, suppressError);
        }

        //function BrowseForFolder(initialPath) {
        //    return clientService.put('browseforfolder');
        //}

        //function BrowseForFolderCheck(bAbort, browseForFolderDialogId) {
        //    var url = "browseForFolderCheck";
        //    if (bAbort)
        //        url = url + "/1";
        //    else
        //        url = url + "/0";

        //    return clientService.put(url, browseForFolderDialogId);
        //}

        function ProcessFileOperationPacket(fileOperationPacket, suppressError) {
            var deferred = $q.defer();

            if (fileOperationPacket == null) {
                var response = {};
                response.data = null;
                deferred.resolve(response);
            }
            else {
                clientService.put('processFileOperationPacket', fileOperationPacket, suppressError).then(function (response) {
                    deferred.resolve({ data: response });
                }, function (response) {
                    deferred.reject(response);
                });
                //deferred.reject();
            }

            return deferred.promise;
        }

        function GetFileInfos(fileInfoModelList, suppressError) {
            return clientService.put('fileInfos', fileInfoModelList, suppressError);
        }

        function WindowsExplorer(folderPath, suppressError) {
            return clientService.put('windowsExplorer', folderPath, suppressError);
        }


        function GetLocalVirtualLibraryPath(suppressError) {
            service.processing = true;
            var deferred = $q.defer();
            clientService.get('LocalVirtualLibraryPath', null, suppressError).then(function (response) {
                service.vlBasePath = response;
                service.processing = false;
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        function SetLocalVirtualLibraryPath(vlBasePath, suppressError) {
            var deferred = $q.defer();
            service.loading = true;
            clientService.put("LocalVirtualLibraryPath", vlBasePath, suppressError).then(function (response) {
                service.vlBasePath = response;
                service.loading = false;
                deferred.resolve(response);
            }, function () {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        getVLBasePath();

        function GetUNC(path, suppressError) {
            return clientService.put('GetUNC', path, suppressError);
        }

        function GetLocalPath(path, suppressError) {
            return clientService.put('GetLocalPath', path, suppressError);
        }

        function GetMyDocsFolder(suppressError) {
            service.processing = true;
            var deferred = $q.defer();

            clientService.get('GetMyDocsFolder', null, suppressError).then(function (response) {
                service.processing = false;
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        function CreateDirectory(path, suppressError) {
            return clientService.put('CreateDirectory', path, suppressError);
        }

        function isFile(filePNE, suppressError) {
            return clientService.put('isFile', filePNE, suppressError);
        }

        function isDirectory(path, suppressError) {
            return clientService.put('isDirectory', path, suppressError);
        }

        function TestAccess(filePNE, suppressError) {
            return clientService.put('testaccess', filePNE, suppressError);
        }

        function TestAccessList(filePNEList, suppressError) {
            return clientService.put('testaccesslist', filePNEList, suppressError);
        }

        //bill 11-20-2017 Returns HTTP OK (200) or HTTP NoContent (204)
        //function WillExtractFile(filePNE) {
        //    return clientService.put('values/PlugInWillExtract', filePNE);
        //}

        //api/values/PlugInExtract/{fullPath}/{extractText}
        function ExtractFile(filePNE, suppressError) {
            return clientService.put('values/PlugInExtract', filePNE, suppressError);
        }

        function GetMappedFields(fileNE, suppressError) {
            return clientService.put('values/MappedFieldsForPlugin', fileNE, suppressError);
        }

        function UpdateDocumentChildrenNeeded(filename) {
            return clientService.post('values/UpdateDocumentChildrenNeeded', filename);
        }

        function UpdateDocument(updateDocumentParameters, suppressError) {
            var deferred = $q.defer();
            SchemaService.GetAllSchemaModels().then(function (data) {
                updateDocumentParameters.schemas = data;
                clientService.post('values/UpdateDocument', updateDocumentParameters, suppressError).then(function (response) {
                    deferred.resolve(response);
                }, function (response) {
                        deferred.reject(response);
                });
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

       //api/values/SetPluginData
        function AcsInitPlugIns(plugInData, suppressError) {
            service.processing = true;
            var deferred = $q.defer();
            clientService.put('values/SetPluginData', plugInData, suppressError).then(function (response) {
                service.bAcsInitPlugInsDone = true;
                service.loading = false;
                deferred.resolve(response);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function OpenFile(filePNE, suppressError) {
            service.processing = true;
            return clientService.put('values/OpenFile', filePNE, suppressError);
        }

        function ValidateWorkAreas(workAreaModels, suppressError) {
            service.processing = true;
            return clientService.put('values/ValidateWorkAreas', workAreaModels, suppressError);
        }

        function CopyFiles(fromDir, toDir, suppressError) {
            var deferred = $q.defer();
            var strings = [];
            strings.push(fromDir);
            strings.push(toDir);
            service.loading = true;
            clientService.put("values/CopyFiles", strings, suppressError).then(function (response) {
                service.loading = false;
                deferred.resolve(response);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
